module.exports = __webpack_public_path__ + "static/media/partyMenu.19414a6f.pdf";